
export enum OrganizationSnackbarMessage {
  UpdateOrganizationFailed = 'An error occurred during the process.',
  UpdateOrganizationSuccess = 'Organization was successfully updated.',
  CreateOrganizationSuccess = 'Organization was successfully created.',
  CreateOrganizationFailed = 'An error occurred during the process.',
}
